import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../Helpers/useAuth';
import { Spinner } from '@heroui/react';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, isLoading, userStatus } = useAuth();
  const location = useLocation();

  // Mostrar loading mientras se verifica la autenticación
  if (isLoading || userStatus === 'buscando') {
    return (
      <div className='w-full h-screen flex items-center justify-center bg-gray-50'>
        <div className='flex flex-col items-center gap-4'>
          <Spinner size="lg" color="primary" />
          <p className='text-gray-600 text-lg'>Verificando autenticación...</p>
        </div>
      </div>
    );
  }

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Si está autenticado, mostrar el componente protegido
  return children;
};

export default PrivateRoute; 